module.exports = __webpack_public_path__ + "static/img/img-carousel-prop-3-v2.0dcc7c3.jpg";